import {
  Component,
  inject,
  OnInit
} from '@angular/core';
import { OttoOlsenPimEditConfigService } from '../../../services/otto-olsen-pim-edit-config.service';
import { OttoOlsenAssortmentTreeNavigationComponent } from '../../otto-olsen-assortment-tree-navigation/otto-olsen-assortment-tree-navigation.component';

@Component({
    selector: 'otto-olsen-mobile-assortment-tree-navigation',
    templateUrl: './otto-olsen-mobile-assortment-tree-navigation.component.html',
    styleUrls: ['./otto-olsen-mobile-assortment-tree-navigation.component.scss'],
    standalone: false
})
export class OttoOlsenMobileAssortmentTreeNavigationComponent
  extends OttoOlsenAssortmentTreeNavigationComponent
  implements OnInit
{
  protected ottoOlsenPimEditConfigService = inject(OttoOlsenPimEditConfigService);
 
}
